<template lang="pug">
  .is-overlay.loading
    .card
      header.card-header
        p.card-header-title
          slot(name="title")
        a.card-header-icon
          span.icon
            slot(name="topIcon")
              i.fa.fa-thumbs-up
      .card-content
        slot
          small Esta operación
          strong &nbsp;no se puede&nbsp;
          small revertir
          br
        slot(name="information")
      footer.card-footer
        a.card-footer-item(
          @click="emitDo"
          :class="{ 'is-disabled': loading }"
        )
          slot(name="primaryAction")
        a.card-footer-item(
          @click="$emit('close')"
        ) Cancelar
</template>

<script>
export default {
  name: 'confirmar_accion_overlay',
  data () {
    return {
      loading: false
    }
  },
  created () {
  },
  methods: {
    emitDo () {
      var vm = this
      if (vm.loading) return
      vm.loading = true
      vm.$emit('do')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .is-overlay
    background-color rgba(162, 162, 162, 0.16);
    width: 101%;
    height: 105%;
    position: absolute;
    top: -5px;
    left: 0;
    z-index: 1000
    padding: .75rem;
    display flex
    justify-content center
    align-items center
    border-radius 3px
  .is-disabled
    pointer-events none
    color #e1e1e1

</style>



// WEBPACK FOOTER //
// Component_Confirmar_Accion_Overlay.vue?75216dea